export default {
    "short" : {
        'phone' : {
            'show': false
        }
    },
    "short-2-col" : {
        'phone' : {
            'show': false
        }
    },
    "short-company_size" : {
        'phone' : {
            'show': false
        }
    },
    "short-comments" : {
        'phone' : {
            'show': false
        }
    },
    "medium" : {
        'phone' : {
            'show': false
        }
    },
    "medium-2-col" : {
        'phone' : {
            'show': false
        }
    },
    "long" : {
        'phone' : {
            'show': false
        }
    },
    "email-only" : {
        'settings' : {
            'demandbaseWidgetEnabled' : false
        }
    },
    'short-ppi-phone-comments' : {
        'phone' : {
            'show': true
        }
    }
}